import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { paises } from '../../assets/paises';
import { Modal, Button, Form, Input, Radio, Row, Col, message, Spin } from 'antd';
import MaskedInput from 'react-input-mask'
import api from '../../services/api';
import { jsPDF } from 'jspdf'
import { autoTable } from 'jspdf-autotable'
import 'antd/dist/antd.css';
import * as ModalStatusAction from '../../redux/actions/modalStatus'
import * as PermissaoAction from '../../redux/actions/permissao'
import { connect } from 'react-redux';
import { Table, Tag, Space } from 'antd';
import { bindActionCreators } from 'redux';

interface ModalAgendamentosPorPeriodoProps {
    modalStatus?: any,
    permissao?: any,
    setAgendamentosPorPeriodoModal?: any
}

const ModalAgendamentosPorPeriodo: React.FC<ModalAgendamentosPorPeriodoProps> = (prop) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);


    let visible = prop.modalStatus[0].visibleAgendamentosPorPeriodo;

    const { Column, ColumnGroup } = Table;

    const handleCancel = () => {
        prop.setAgendamentosPorPeriodoModal(false);
    };
    const ImprimirAgendamentosDeHoje = async () => {
        //-------------
        let dataInicio = '2021/06/18 17:15:56';


        //-----------
    }

    function ajustandoData(data: any) {

        let dateParts = data.split('/');

        let dateFull = dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0];

        return moment(dateFull).format();

    }

    const maskCel = (input: string) => {
        return input
            .replace(/\D/g, "")
            .replace(/(\d{1})/, "($1")
            .replace(/(\d{2})(\d)/, "$1) $2")
            .replace(/(9?\d{4})(\d)/, "$1-$2")
            .replace(/(-\d{4})(\d+?)$/, "$1");
    };

    const onFinish = async (values: any) => {

        let dataInicio = ajustandoData(values.dataInicio);
        const formatDataInicio = moment(dataInicio).format('DD/MM/YYYY')
        let dataFim = ajustandoData(values.dataFim);
        const formatDataFim = moment(dataFim).format('DD/MM/YYYY')
        let tituloDoc;
        await api.get(`Agendamento/getagendamentobydata?dataInicio=${dataInicio}&dataFim=${dataFim}`, {
        })
            .then((response: any) => {
                message.success("Seu relatório será baixado com sucesso!");

                prop.setAgendamentosPorPeriodoModal(true);

                const doc = new jsPDF();

                doc.setTextColor(100, 100, 100);

                if (dataInicio === dataFim) {
                    tituloDoc = "Agendamento(s) do período " + formatDataInicio
                    doc.text("Agendamento(s) do período", 50, 15, undefined, 'justify');
                    doc.text(formatDataInicio, 125, 15, undefined, 'justify')

                }
                else {
                    tituloDoc = "Agendamento(s) do período de " + formatDataInicio + " à " + formatDataFim
                    doc.text("Agendamento(s) do período de", 100, 15, undefined, 'center');
                    doc.text(formatDataInicio, 80, 25, undefined, 'center');
                    doc.text("à", 100, 25, undefined, 'center');
                    doc.text(formatDataFim, 120, 25, undefined, 'center');
                }

                for (let i = 0; i < response.data.agendamentos.length; i++) {
                    moment.locale('pt-br');
                    let hora_inicio = moment(response.data.agendamentos[i].dataHoraInicio).format('DD/MM/YYYY HH:mm');
                    let hora_fim = moment(response.data.agendamentos[i].dataHoraFim).format('DD/MM/YYYY HH:mm');

                    response.data.agendamentos[i].dataHoraInicio = hora_inicio;

                    response.data.agendamentos[i].dataHoraFinal = hora_fim;

                    response.data.agendamentos[i].telefone = response.data.agendamentos[i].telefone == null ? '' : maskCel(response.data.agendamentos[i].telefone)

                    if (i == 0) {
                        autoTable(doc, {
                            margin: { vertical: 45 },
                            theme: 'grid',
                            styles: {
                                halign: 'center',
                                valign: 'middle',
                                fontSize: 8,
                            },
                            head: [['Data - Hora', 'Nome - País de Ogirem', 'Telefone', 'Motivo']],
                            body: [
                                response.data.agendamentos[i],
                            ],
                            columns: [
                                { dataKey: 'dataHoraInicio' },
                                { dataKey: 'nome' },
                                { dataKey: 'telefone' },
                                { dataKey: 'motivo' },
                            ],
                            columnStyles: {
                                0: { cellWidth: 30 },
                                1: { cellWidth: 50 },
                                2: { cellWidth: 40 },
                                4: { cellWidth: 60 },
                            },

                        })
                    }
                    else {
                        autoTable(doc, {
                            margin: 0,
                            theme: 'grid',
                            styles: {
                                halign: 'center',
                                valign: 'middle',
                                fontSize: 8,
                            },

                            body: [
                                response.data.agendamentos[i],
                            ],
                            columns: [
                                { dataKey: 'dataHoraInicio' },
                                { dataKey: 'nome' },
                                { dataKey: 'telefone' },
                                { dataKey: 'motivo' },
                            ],
                            columnStyles: {
                                0: { cellWidth: 30 },
                                1: { cellWidth: 50 },
                                2: { cellWidth: 40 },
                                4: { cellWidth: 60 },
                            },

                        })
                    }
                }

                doc.save(`${tituloDoc}.pdf`);
            })
            .catch((err) => {
                message.error('Falha na requisição')
                // setLoading(false);
            });

        // setLoading(true);
        setTimeout(() => {
            // setLoading(false);
        }, 50);

    };
    const onFinishFailed = (errorInfo: any) => {
    };
    return (

        <Modal
            visible={visible}
            title="Agendamentos Por Período Descrito"
            onCancel={handleCancel}
            footer={null}
        >
            <Spin spinning={loading}>

                <Form
                    name="agendamento"
                    onFinish={onFinish}
                    form={form}
                    onFinishFailed={onFinishFailed}
                    layout="vertical"
                >

                    <Form.Item
                        label="Data Início"
                        name="dataInicio"
                        rules={[
                            {
                                required: true,
                                message: 'Por favor insira uma Data Início!',
                            }
                        ]}
                    >
                        <MaskedInput className="ant-input" placeholder="__/__/____" mask="99/99/9999" />
                    </Form.Item>
                    <Form.Item
                        label="Data Fim"
                        name="dataFim"
                        rules={[
                            {
                                required: true,
                                message: 'Por favor insira uma Data Fim!',
                            }
                        ]}
                    >
                        <MaskedInput className="ant-input" placeholder="__/__/____" mask="99/99/9999" />
                    </Form.Item>
                    <Form.Item>
                        {prop.permissao[0]?.permissaoAcesso?.cadastrar === true ?
                            <Button className="button-agendar" type="primary" htmlType="submit">
                                Procurar
                            </Button>
                            : null}
                    </Form.Item>

                </Form>

            </Spin>
        </Modal>

    );
}

const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
    periodo: state.periodo,
    permissao: state.permissao
})

const mapDispatcToProps = (dispatch: any) => {
    return bindActionCreators(Object.assign({}, PermissaoAction, ModalStatusAction), dispatch);
}
export default connect(mapStateToProps, mapDispatcToProps)(ModalAgendamentosPorPeriodo);
